import { render, staticRenderFns } from "./VoiceRoomGiftModal.vue?vue&type=template&id=76b9714a&scoped=true"
import script from "./VoiceRoomGiftModal.vue?vue&type=script&lang=js"
export * from "./VoiceRoomGiftModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceRoomGiftModal.vue?vue&type=style&index=0&id=76b9714a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b9714a",
  null
  
)

export default component.exports